/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    TapeJobSource,
    TapeJobSourceFromJSON,
    TapeJobSourceFromJSONTyped,
    TapeJobSourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface RestoreEndpointRequest
 */
export interface RestoreEndpointRequest {
    /**
     * 
     * @type {string}
     * @memberof RestoreEndpointRequest
     */
    name: string;
    /**
     * 
     * @type {Array<TapeJobSource>}
     * @memberof RestoreEndpointRequest
     */
    source: Array<TapeJobSource>;
    /**
     * 
     * @type {Array<string>}
     * @memberof RestoreEndpointRequest
     */
    exclude: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof RestoreEndpointRequest
     */
    tape: string;
    /**
     * 
     * @type {string}
     * @memberof RestoreEndpointRequest
     */
    destination?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof RestoreEndpointRequest
     */
    _export?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof RestoreEndpointRequest
     */
    startDate: Date;
}

export function RestoreEndpointRequestFromJSON(json: any): RestoreEndpointRequest {
    return RestoreEndpointRequestFromJSONTyped(json, false);
}

export function RestoreEndpointRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RestoreEndpointRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'source': ((json['source'] as Array<any>).map(TapeJobSourceFromJSON)),
        'exclude': json['exclude'],
        'tape': json['tape'],
        'destination': !exists(json, 'destination') ? undefined : json['destination'],
        '_export': !exists(json, 'export') ? undefined : json['export'],
        'startDate': (new Date(json['start_date'])),
    };
}

export function RestoreEndpointRequestToJSON(value?: RestoreEndpointRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'source': ((value.source as Array<any>).map(TapeJobSourceToJSON)),
        'exclude': value.exclude,
        'tape': value.tape,
        'destination': value.destination,
        'export': value._export,
        'start_date': (value.startDate.toISOString()),
    };
}


